import React from "react"; //eslint-disable-line

export interface TextAreaProps {
  rows?: number;
  value: string;
  name: string;
  className?: string;
  autoFocus: boolean;
  errorMessage?: string;
  placeHolder?: string;
  label?: string;
  ref?: any;
  required?: boolean;
  onClick?: (e: any) => void;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  onKeyDown?: (e: any) => void;
  onFocus?: (e: any) => void;
}

const Textarea: React.FC<TextAreaProps> = (props) => {
  return (
    <div className="text-area-wrapper">
      <div>
        {props?.label && (
          <label>
            {props?.label}
            {props.required && <span className="required">*</span>}
          </label>
        )}
      </div>
      <textarea
        name={props?.name}
        className={`text-area ${props?.errorMessage ? "error" : ""}`}
        autoFocus={props?.autoFocus}
        value={props?.value}
        onChange={props?.onChange}
        onBlur={props?.onBlur}
        placeholder={props?.placeHolder}
      ></textarea>
      {props?.errorMessage && (
        <div className="error-message align-self-center">
          {props?.errorMessage}
        </div>
      )}
    </div>
  );
};

export default Textarea;
